import React from 'react';
import DashboardSidebar from '../components/DashboardComponents/DashboardSidebar';
import AdminNewsCreateForm from '../components/AdminComponents/AdminNewsCreateForm';
import InnerBanner from '../components/PagesComponents/InnerBanner';
const AdminNewsCreate = () => {
 return (
    <>
    {/* <InnerBanner pageKey="adminBlogs" /> */}
      <section className='profile-sec py-5'>
        <div className='container'>
            <div className='row'>
                <div className='col-lg-12'>
                     <AdminNewsCreateForm/>
                </div>
              
            </div>
        </div>
      </section>
    </>
 );

};

export default AdminNewsCreate;
